import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppSettingsResolver } from '@commoncore/resolvers/appsettings.resolver';
import { FileOperationsResolver } from '@commoncore/resolvers/file-operations.resolver';
import { signinResolver } from '@commoncore/resolvers/signin.resolver';
import { EnableSemanticSearch } from './core/guards/semantic-search.guard';


const routes: Routes = [
  {
    path: '',
    data:{'jchome':true},
    pathMatch: 'full',
    runGuardsAndResolvers: 'always',
    resolve: { FileOperationsResolver, AppSettingsResolver },
    loadComponent: () => import('@common-standalone/landing/landing/landing.component').then(m => m.LandingComponent)
  },
  {
    path: 'about',
    redirectTo:''
  },
  {
    path: 'jiocloudpc',
    resolve: { AppSettingsResolver },
    loadChildren: () => import('@mainrepo/app/standalone-routes/jiocloud-pc-routes').then(m => m.JIO_CLOUD_PC_ROUTES)
  },
  {
    path: 'pricing',
    data:{'jchome':true},
    resolve: { FileOperationsResolver, AppSettingsResolver },
    // redirectTo:'about', //commenting this, as we are using a guard to activate pricing component, as there are multiple scenarios like, enablePricingTab (env specific flag) and jioid users login
    loadChildren: () => import('projects/common-repo/src/app/modules/pricing/pricing.module').then(m => m.PricingModule)
  },
  {
    path: 'features',
    data:{'jchome':true},
    resolve: { FileOperationsResolver, AppSettingsResolver },
    loadChildren: () => import('@mainrepo-standalone-routes/features-routes').then(m => m.WHATS_NEW_ROUTES)
  },
  {
    path: 'signin',
    data:{'jchome':true},
    resolve: { signinResolver,FileOperationsResolver, AppSettingsResolver },
    loadComponent: () => import('@common-standalone/logins/login-wrapper/login-wrapper.component').then(m => m.LoginWrapperComponent)
  },
  {
    path: 'events',
    resolve: { AppSettingsResolver },
    loadChildren: () => import('@mainrepo-standalone-routes/events-routes').then(m => m.EVENTS_ROUTES)
  },
  {
    path: 'sign-up',
    resolve: { AppSettingsResolver },
    loadComponent: () => import('@common-standalone/events/eventsjc/eventsjc.component').then(m => m.EventsjcComponent)

  },
// {
  //   path: 'features/:hash',
  //   data:{'jchome':true},
  //   loadChildren: () => import('projects/common-repo/src/app/modules/whats-new/whats-new.module').then(m => m.WhatsNewModule)
  // },
  { path: 'a',
    resolve: { AppSettingsResolver },
    loadComponent: () => import('@mainrepo-standalone/autologin/auto-login/auto-login.component').then(mod => mod.AutoLoginComponent)
  },
  { path: 'auToLoginTest',
    resolve: { AppSettingsResolver },
    loadComponent: () => import('@mainrepo-standalone/autologin/auto-login-test/auto-login-test.component').then(m => m.AutoLoginTestComponent)
  },
  {
    path: 'downloadApp',
    data:{'jchome':true},
    resolve: { FileOperationsResolver, AppSettingsResolver },
    loadComponent: () => import('@common-standalone/landing/download-app/download-app.component').then(m => m.DownloadAppComponent)
  },
  // {
  //   path: 'promotions',
  //   loadChildren: () => import('@mainrepo/app/modules/gaming/gaming.module').then(m => m.GamingModule)
  // },
  {
    path: 'document',
    resolve: { AppSettingsResolver },
    loadChildren: () => import('@mainrepo-standalone-routes/office-for-web-routes').then(m => m.OFFICE_FOR_WEB_ROUTES)
  },
  {
    path: 'jc-photo',
    resolve: { AppSettingsResolver },
    loadChildren: () => import('@mainrepo-standalone-routes/photo-edit-routes').then(m => m.PHOTO_EDIT)
  },
  {
    path: 'searchdetails',
    canActivate:[EnableSemanticSearch],
    resolve: { AppSettingsResolver },
    data:{check:"isStatsTwoAiEnabled"},
    loadComponent: ()=> import("@mainrepo-standalone/sematic-search-status-details/sematic-search-status-details.component").then(c=>c.SematicSearchStatusDetailsComponent)
  },
  {
    path: '',
    loadChildren: () => import('@mainrepo/app/modules/home/home.module').then(m => m.HomeModule)
  },
  {
    path: '**',
    redirectTo: 'home',
    pathMatch: 'full'
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{ scrollPositionRestoration: 'top', enableTracing:false})],
  exports: [RouterModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppRoutingModule { }
